import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import PURCHASEIRQConfirmationView from "../views/PurchaseIrqConfirmationView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { array, date, number, object, string } from "yup";
import { getDateFourteenDaysFromNow } from "../util/getDateFourteenDaysFromNow";
import StatusCheck from "../components/StatusCheck";

class PurchaseIrqConfirmationPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    const minDate = getDateFourteenDaysFromNow();

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="purchaseIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            street: string().required(),
            city: string().required(),
            county: string().required(),
            state: string().required(),
            zip: string().required(),
            plannedClosingDate: date()
              .required()
              .min(minDate, "date must be at least 15 days in the future"), // we're enforcing 14 but need to have 15 to account for millisecond differences
            price: number().required().min(100).max(100_000_000),
            downPayment: number().required().min(0).max(100_000_000),
            creditScore: number()
              .typeError("Provided value is invalid")
              .required()
              .min(300)
              .max(850),
            loanOptions: array().required().min(1),
          })}
        >
          <PURCHASEIRQConfirmationView
            content={contentMap.PurchaseIrqConfirmationPage}
            navigationsAway={customNavigationMap.PurchaseIrqConfirmationPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(PurchaseIrqConfirmationPage);
